import { Button, Container, ContainerFluid } from '../../components';
import styles from './mvp-contact.module.css';

export default function MVPContact() {
  return (
    <ContainerFluid>
      <section className={styles.contact}>
        <Container>
          <div className={styles.wrapper}>
            <div className={styles.start}>
              <h3 className={styles.title}>MVP First. Full Vision Next.</h3>
              <p className={styles.text}>
                This MVP is your starting line — not the finish. <br />
                In just 6 weeks, we help you launch a focused, functional
                Version #1 to validate your idea with real users. Once it’s
                live, we collect insights, iterate fast, and keep building
                toward your full product vision.
              </p>
            </div>
            <div className={styles.end}>
              <Button
                tag="a"
                href="#contact"
                className={styles.button}
                appearance="primary"
              >
                Contact us
              </Button>
            </div>
          </div>
        </Container>
      </section>
    </ContainerFluid>
  );
}
